import React from "react";
import { useParams, useRouteMatch } from "react-router-dom";
import { useAccountTickets } from "../hooks/useAccountTickets";
import { FinancialDetail } from "./FinancialDetail";
import { Typography, BoxProps } from "@material-ui/core";

export const Tickets: React.FC<BoxProps> = ({ ...props }) => {
  const { accountNumber } = useParams();
  const { data: tickets, status } = useAccountTickets(
    accountNumber,
    "Open,Error",
  );
  const { url } = useRouteMatch();

  return (
    <FinancialDetail
      loading={status === "loading"}
      link={{ text: "View Tickets", path: `${url}/tickets` }}
      title="Tickets (open, error)"
      {...props}
    >
      <Typography variant="h5" color="textPrimary" component="span">
        {tickets?.length}
      </Typography>
    </FinancialDetail>
  );
};
